<template>
    <main-layout>
        <template #header>
            <main-header :title="'시스템 권한 그룹 관리'">
            </main-header>
        </template>

        <template #toolbar>
        </template>

        <template #body>
            <div style="flex-grow: 0;">
                <v-tabs
                        v-model="tab"
                        background-color="primary"
                        dark
                >
                    <v-tab
                            v-for="item in tabs"
                            :key="item.key"
                    >
                        {{ item.text }}
                    </v-tab>
                </v-tabs>
            </div>

            <div style="flex-grow: 1;">
                <v-tabs-items v-model="tab" class="fill-height">
                    <v-tab-item
                            class="fill-height"
                            v-for="item in tabs"
                            :key="item.key"
                    >
                        <component :is="item.component"></component>
                    </v-tab-item>
                </v-tabs-items>
            </div>
        </template>
    </main-layout>
</template>
<script>
    import MainHeader from "@/components/common/layout/MainHeader";
    import MainLayout from "@/components/common/layout/MainLayout";
    import OnSystemPermissionGroupReceivedListener from "@/framework/listeners/OnSystemPermissionGroupReceivedListener";
    import SystemPermissionGroupManageBySystem
        from "@/views/permission/group-manage/SystemPermissionGroupManageBySystem";
    import SystemPermissionGroupManageByRentalcompany
        from "@/views/permission/group-manage/SystemPermissionGroupManageByRentalcompany";

    export default {
        name: "SystemPermissionGroupManage",
        components: {MainLayout, MainHeader},
        mixins: [OnSystemPermissionGroupReceivedListener],
        data() {
            return {
                tab: "system",
                tabs: [
                    {
                        key: "system",
                        text: "시스템 권한 그룹",
                        component: SystemPermissionGroupManageBySystem,
                    },
                    {
                        key: "rentalcompany",
                        text: "임대사업자 권한 그룹",
                        component: SystemPermissionGroupManageByRentalcompany,
                    },
                ]
            };
        },
        methods: {
        },
    }
</script>

<style scoped>

</style>